import {take, put, fork, select} from 'redux-saga/effects';
import {openModal, closeModal} from '@computerrock/formation-router/sagas';
import {Vehicle} from '@ace-de/eua-entity-types';
import fetchRequest from '../../application/sagas/fetchRequest';
import modalIds from '../../modalIds';
import updateServiceCase from './updateServiceCase';
import * as serviceCaseActionTypes from '../serviceCaseActionTypes';
import * as memberActionTypes from '../../members/memberActionTypes';

/**
 * Service case vehicle create flow (uses modal)
 * creates a new vehicle on the AMP & patches the vehicle snapshot on a case
 */
const createServiceCaseVehicleFlow = function* createServiceCaseVehicleFlow() {
    const {serviceManager} = yield select(state => state.application);
    const membersService = serviceManager.loadService('membersService');

    while (true) {
        yield take(serviceCaseActionTypes.INITIATE_CREATE_SERVICE_CASE_VEHICLE_FLOW);

        yield* openModal(modalIds.VEHICLE_DATA);
        const chosenModalOption = yield take([
            serviceCaseActionTypes.CONFIRM_CREATE_SERVICE_CASE_VEHICLE,
            serviceCaseActionTypes.DECLINE_CREATE_SERVICE_CASE_VEHICLE,
        ]);

        if (chosenModalOption
            && chosenModalOption.type === serviceCaseActionTypes.CONFIRM_CREATE_SERVICE_CASE_VEHICLE) {
            const {payload} = chosenModalOption;
            const {membershipNo, memberVehicle, serviceCaseData, serviceCaseId, caseType} = payload;

            yield fork(
                fetchRequest,
                memberActionTypes.CREATE_MEMBER_VEHICLE_REQUEST,
                membersService.createMemberVehicle,
                {
                    memberVehicleDTO: Vehicle.objectToDTO(memberVehicle),
                },
            );
            const responseAction = yield take([
                memberActionTypes.CREATE_MEMBER_VEHICLE_REQUEST_SUCCEEDED,
                memberActionTypes.CREATE_MEMBER_VEHICLE_REQUEST_FAILED,
            ]);

            if (!responseAction.error) {
                const {response} = responseAction.payload;
                const {memberVehicleDTO} = response;

                yield put({
                    type: memberActionTypes.STORE_MEMBER_VEHICLE,
                    payload: {membershipNo, memberVehicleDTO},
                });

                if (memberVehicleDTO.id) {
                    yield* updateServiceCase({
                        caller: serviceCaseActionTypes.CONFIRM_CREATE_SERVICE_CASE_VEHICLE,
                        caseType,
                        serviceCaseId,
                        serviceCaseData: {
                            ...serviceCaseData,
                            vehicle: {
                                ...serviceCaseData.vehicle,
                                vehicleId: memberVehicleDTO.id,
                            },
                        },
                    });
                }
            }
        }

        yield* closeModal(modalIds.VEHICLE_DATA);
    }
};

export default createServiceCaseVehicleFlow;
